import {Injectable} from '@angular/core';
import {CheckListStrategy} from './check-list.strategy';
import {Checkpoint} from '../../../data/checkpoint.model';
import {CheckpointStage} from '../../../data/checkpoint-stage.enum';
import {CheckpointType} from '../../../data/checkpoint-type.enum';


@Injectable()
export class DevelopmentCheckListStrategy implements CheckListStrategy {

  availableTypes: CheckpointType[] = [CheckpointType.Development, CheckpointType.Test];
  stage = CheckpointStage.Development;
  getDefaultValue(): Partial<Checkpoint> {
    return {
      type: CheckpointType.Development
    };
  }
}
